import { listToMap, renderIntlLabel } from '@/utils';

export const OtherOrderTypeOptions = [
  {
    label: '1',
    value: '1',
  },
];

export const PaymentStatusOptions = [
  {
    label: renderIntlLabel('order_crs_enum_PaymentStatusOptions_TO_BE_PAID'),
    value: 'TO_BE_PAID',
  },
  {
    label: renderIntlLabel('order_crs_enum_PaymentStatusOptions_PAID'),
    value: 'PAID',
  },
  {
    label: renderIntlLabel('order_crs_enum_PaymentStatusOptions_OVER_TIME_CLOSE'),
    value: 'OVER_TIME_CLOSE',
  },
  {
    label: renderIntlLabel('order_crs_enum_PaymentStatusOptions_STORE_CANCELD'),
    value: 'STORE_CANCELD',
  },
];

// 入住类型
export enum OccType {
  DAILY = 'DAILY',
  HOUR = 'HOUR',
}
export const OCC_TYPE_LIST = [
  { label: renderIntlLabel('order_option_label_daily'), value: OccType.DAILY },
  { label: renderIntlLabel('order_option_label_hour'), value: OccType.HOUR },
];
export const OCC_TYPE_MAP = listToMap(OCC_TYPE_LIST);

export const PAY_MENT_STATUS_MAP = listToMap(PaymentStatusOptions);
